module.exports = {
    BASE_URL_DEMO: process.env.NEXT_PUBLIC_DEMO_URL || 'https://jsonplaceholder.typicode.com/',
    BASE_URL: process.env.NEXT_PUBLIC_API_URL || 'https://cms.shantasecurities.com/api/',
    MAP_API_KEY: process.env.NEXT_PUBLIC_MAP_API_KEY || 'AIzaSyB3nEqKsliw_EQSpaxAq6R8hOUwpGyxJ9s',
    CSV: process.env.NEXT_PUBLIC_CSV_URL || 'https://1.api.voyager6.com/output/adj_returns_portfolio.csv'
}
